import { ClientBankAccountsLists, ClientBankAccountsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchBankAccounts() {
  const api = useApi();
  // One value instead of a fetching/hasFetched pair, because "never fetched" and "the last fetch
  // failed" want different renders and two booleans can't tell them apart - both are false. The
  // accounts in bankAccounts are whatever the last *successful* fetch returned: a failure sets
  // 'error' without clearing them, so a consumer can keep showing the previous list and say so.
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [bankAccounts, setBankAccounts] = useState<ClientBankAccountsLists[]>([]);

  // PortalUser omitted: no earthnode handler for this endpoint reads it (verified against
  // lib/www/routes/v2/bank_account.php) — the backend takes the user from the JWT.
  async function fetchBankAccounts(params: Omit<ClientBankAccountsRequest, 'PortalUser'>) {
    try {
      setStatus('loading');
      const res = await api.fetchClientBankAccounts(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setBankAccounts(res.BankAccounts);
      setStatus('success');

      return res;
    } catch (error) {
      setStatus('error');
      console.error(error);
      throw error;
    }
  }

  return { status, bankAccounts, fetchBankAccounts };
}
